import React from "react";
import { Link, Script, useStaticQuery, graphql } from "gatsby";
import { Flex } from "theme-ui";
import { NavItemProps } from "../components/Nav/Nav";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import LogoSocialBox from "../components/Boxes/LogoSocialBox";

const Footer: React.FC = () => {
  const data = useStaticQuery(graphql`
    query FooterBlockQuery {
      allDataJson {
        edges {
          node {
            Footer {
              heading {
                text
                color
              }
              routes {
                route
                path
              }
              disclaimers
            }
          }
        }
      }
    }
  `);

  const { routes, disclaimers, heading } =
    data.allDataJson.edges[0].node.Footer;

  return (
    <footer
      sx={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        pb: 5,
        pt: 4,
      }}
    >
      <Flex
        sx={{
          flexDirection: ["column", null, null, "row"],
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          p: {
            fontSize: 18,
          },
        }}
      >
        {routes.map((r: NavItemProps, i: number) => (
          <Link
            key={i}
            to={r.path}
            sx={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <p
              sx={{
                fontWeight: 600,
                my: 2,
                mx: 3,
              }}
            >
              {r.route}
            </p>
          </Link>
        ))}
      </Flex>
      <h2
        sx={{
          color: heading.color,
          fontWeight: 400,
          fontSize: [22, 32],
          letterSpacing: "4px",
        }}
      >
        {heading.text}
      </h2>
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <LogoSocialBox
          logo="heights"
          icons={["facebook", "instagram", "linkedin"]}
          urls={[
            "https://www.facebook.com/HeightsFinance/",
            "https://www.instagram.com/heightsfinance/",
            "https://www.linkedin.com/company/heights-finance-corporation/",
          ]}
        />
        <LogoSocialBox
          logo="southern"
          icons={["facebook", "instagram"]}
          urls={[
            "https://www.facebook.com/SouthernFinance.SMC/",
            "https://www.instagram.com/southern_finance",
          ]}
        />
        <LogoSocialBox
          logo="convington"
          icons={["facebook", "instagram"]}
          urls={[
            "https://www.facebook.com/CovingtonCredit/",
            "https://www.instagram.com/covington_credit/",
          ]}
        />
        <LogoSocialBox
          logo="quick"
          icons={["facebook", "instagram"]}
          urls={[
            "https://www.facebook.com/Quick-Credit-1897225660493044/",
            "https://www.instagram.com/quick_credit",
          ]}
        />
      </Flex>
      <Link
        to="/download-app"
        sx={{
          py: 3,
        }}
      >
        <StaticImage
          src="../images/download-app/HeightsDownloadAppIcon.png"
          alt="heights app download"
          sx={{
            width: 180,
          }}
        />
        {/* <GatsbyImage
          image={data.app.childImageSharp.gatsbyImageData}
          alt="heights app download"
          sx={{
            width: 200,
          }}
        /> */}
      </Link>
      <p
        sx={{
          variant: "text.disclaimer",
          px: [3, null, null, 4],
        }}
      >
        {" "}
        © {new Date().getFullYear()} Heights Finance. All Rights Reserved.
      </p>
      {disclaimers.map((disclaimer: string, i: number) => (
        <p
          sx={{
            variant: "text.disclaimer",
            px: [3, null, null, 4],
          }}
          key={i}
          dangerouslySetInnerHTML={{ __html: disclaimer }}
        />
      ))}
    </footer>
  );
};
export default Footer;
